import { render, staticRenderFns } from "./CalendarYear.vue?vue&type=template&id=d6d22dd8&"
import script from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarYear.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6d22dd8')) {
      api.createRecord('d6d22dd8', component.options)
    } else {
      api.reload('d6d22dd8', component.options)
    }
    module.hot.accept("./CalendarYear.vue?vue&type=template&id=d6d22dd8&", function () {
      api.rerender('d6d22dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/components/CalendarYear.vue"
export default component.exports